<template>

  <div>
    <div class="row px-0 mx-1 contenedor">

      <div id="image-card" class="col-md-8">
        <div class="c-app flex-row align-items-center col-12">
          <img  class="banner-image" src="../../public/banner.jpg" alt="">
        </div>
        <!-- <div class="c-app flex-row align-items-center col-3">
          <img  class="banner-image" src="../../public/2.png" alt="">
        </div>
        <div class="c-app flex-row align-items-center col-3">
          <img  class="banner-image" src="../../public/3.png" alt="">
        </div>
        <div class="c-app flex-row align-items-center col-3">
          <img  class="banner-image" src="../../public/4.png" alt="">
        </div> -->
      </div>

      <div id="login-card" class="col-md-4">
        <div class="c-app flex-row align-items-center">
          <CContainer>
            <CRow class="justify-content-center">
              <!-- <CCol md="6">
                <CCardGroup>
                  <CCard class="p-1 opacity_card">
                    <CCardBody> -->
                      <CForm>
                        <div class="float-right cont_logo">
                          <img  class="float-center imgresp" src="../../public/logo_howert.png" width="60%" alt="">
                        </div>
                        <p class="text-muted">&nbsp;</p>
                        <CInput placeholder="Usuario" autocomplete="Digite Dni o correo " v-model="login.login">
                          <template #prepend-content>
                            <CIcon name="cil-user" style="color: #0F172A" />
                          </template>
                        </CInput>
                        <CInput placeholder="Contraseña" type="password" autocomplete="curent-password"
                          v-model="login.password" @keypress.enter="mtd_login">
                          <template #prepend-content>
                            <CIcon name="cil-lock-locked" style="color: #0F172A" />
                          </template>
                        </CInput>
                        <CRow>
                          <CCol col="6" class="text-left">
                            <CButton class="px-4 btn-login" @click="mtd_login">Entrar</CButton>
                          </CCol>
                          <!-- <CCol col="6" class="text-right">
                            <CButton color="link" class="px-0">Forgot password?</CButton>
                            <CButton color="link" class="d-lg-none">Register now!</CButton>
                          </CCol> -->
                        </CRow>
                      </CForm>
                      <CAlert :show.sync="alert.dismissCountDown" closeButton :color="alert.color">
                        {{ alert.message }}
                        <CProgress :color="alert.color" :max="alert.dismissSecs" :value="alert.dismissCountDown"
                          :size="'xs'" />
                      </CAlert>
                    <!-- </CCardBody>
                  </CCard>
                </CCardGroup>
              </CCol> -->
            </CRow>
            <CRow class="justify-content-center mt-4">
            <CCol col="12" class="text-center">
              <footer class="footer">
                <p>&copy; HowStore 2025. Todos los derechos reservados <a href="https://howertpi.com/" target="_blank">HowertPi</a>.</p>
              </footer>
            </CCol>
          </CRow>
          </CContainer>
        </div>
      </div>

    </div>
  </div>
  
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      url: "",
      login: {
        login: "",
        password: "",
      },
      alert: {
        dismissSecs: 3,
        dismissCountDown: 0,
        color: "info",
        message: "",
      },
    };
  },
  created() {
    this.url = this.$store.getters.get__url;
    // this.mtdCheckSession();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdCheckSession: function () {
      this.get({
        url: this.url + "/user/check",
        params: this.login,
      })
        .then((response) => {
          // console.log(response);
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_login: function () {
      if (this.login.login != "") {
        if (this.login.password != "") {
          this.post({
            url: this.url + "/user/login",
            params: this.login,
          })
            .then((response) => {
              if (response.state == 0) {
                Swal.fire({
                  icon: "error",
                  title: "Acceso no autorizado",
                });
              } else if (response.state == 1) {
                Swal.fire({
                  icon: "error",
                  title: "Acceso Denegado",
                });
              } else if (response.state == 200) {
                // Limpiar el estado antes de asignar nuevos valores
                this.$store.commit("mt_logout_auth");
                // Asignar los nuevos valores
                this.$store.commit("mt_set_auth", response.user);
                this.$store.commit("mt_set_dataroles", response.dataRol);
                this.$store.commit("mt_set_datacampus", response.dataSede);
                this.$store.commit("mt_set_company", response.company);
                this.$router.push({ path: "home" });
              } else if (response.statusCode == 201) {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Error al iniciar sesión',
                });
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Error al iniciar sesión',
                });
              }
            })
            .catch((errors) => {
              // this.errorsBackend = errors;
              // this.$emit("error", this.event);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error en el servidor',
              });
            });
        } else {
          // this.alert.color = "warning";
          // this.alert.dismissCountDown = 3;
          // this.alert.message = "Digite contraseña";
          Swal.fire({
            icon: 'warning',
            title: 'Error',
            text: 'Digite contraseña',
          });
        }
      } else {
        // this.alert.color = "warning";
        // this.alert.dismissCountDown = 3;
        // this.alert.message = "Digite usuario";
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          text: 'Digite usuario',
        });
      }
    },
    /** alert */
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showDismissibleAlerts() {
      ["alert1", "alert2"].forEach((alert) => (this[alert] = true));
    },
  },
};
</script>
<style scoped>
.alert {
  position: fixed;
  top: 100px;
  left: 1050px;
  width: 30%;
  z-index: 9999;
  border-radius: 0px;
}

.contenedor {
  background-color: rgba(209, 209, 208, 0.8) !important;
  display: flex;
  align-items: center;
  height: 100vh !important; /* Ajusta según sea necesario */
}

.btn-login {
  color: #0F172A;
  background-color: #42B883;
  font-weight: bold;
}

.btn-login:hover {
  color: #DEECFB;
  background-color: #136949;
}

#login-card {
  background-color: rgba(209, 209, 208, 0.8) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

#login-card .c-app {
  background-color: rgba(209, 209, 208, 0.8) !important;
}

#image-card {
  background-color: rgba(209, 209, 208, 0.8) !important;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

#image-card .c-app {
  background-color: rgba(209, 209, 208, 0.8) !important;
}

.banner-image {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: cover;
}

.cont_logo{
  width: 100%;
  font-size: 24pt;
  text-align: center;
}

@media (max-width: 768px) {
  #login-card {
    flex: 0 0 100%;
    max-width: 100%;
    height: 100%;
    align-content: center;
  }

  #login-card .c-app {
    width: 100%;
  }

  #image-card {
    display: none;
  }
}

@media (max-width: 550px) {
  .opacity_card{
    background-color: rgba(255, 255, 255, 0.9);
  }
  .cont_logo{
    width: 100%;
    font-size: 24pt;
    text-align: center;
  }
  .cont_logo img{
    width: 100% !important;
  }
}

</style>
